/**
 * XION Medical product data — Medical monitors
 * Content sourced from xion-medical.com (split from completeProductsData.js).
 */

export const medicalMonitors = {
  id: 'medical-grade-monitors',
  name: 'Medical Grade Monitors',
  slug: 'medical-grade-monitors',
  category: 'Visualization',
  description: 'XION offers monitors with optimal specifications for all areas of application. The models — supplied by established manufacturers — range from 21.5" 2D touch monitors up to 55" 3D monitors, selected and integrated to match each XION endoscopy system.',
  overview: 'From a compact 21.5" touchscreen used as a second or documentation monitor, through high-resolution 2D displays, to large-format 55" 3D monitors for stereoscopic surgery — every monitor is matched to the resolution (HD, 4K/UHD or 3D) of the XION camera platform it is paired with.',
  products: [
    {
      id: 'medical-monitor-27-4k',
      name: '2D Medical Monitors',
      slug: 'medical-monitor-27-4k',
      tagline: 'High-resolution and touch displays from 21.5" upward',
      description: 'XION 2D medical monitors are available in a range of sizes, including a 21.5" touch monitor frequently used as a documentation or second monitor. Resolution is matched to the connected XION camera platform — from HD up to 4K/UHD — for clinic and operating-room visualisation.',
      features: [
        'Range of sizes, including a 21.5" touch monitor',
        'Resolution matched to the XION camera platform (HD to 4K/UHD)',
        'Suitable as a primary, second or documentation monitor',
        'Supplied by established medical-display manufacturers',
        'Integrated with XION camera processors and DiVAS'
      ],
      specifications: {
        type: '2D medical monitor',
        sizes: '21.5" and larger',
        resolution: 'HD to 4K/UHD',
        touch: '21.5" touch option'
      },
      images: ['/products/transparent/xion-monitore-web.png']
    },
    {
      id: 'medical-monitor-32-surgical',
      name: '3D Surgical Monitors',
      slug: 'medical-monitor-32-surgical',
      tagline: 'Large-format stereoscopic visualisation up to 55"',
      description: 'For stereoscopic surgery, XION offers large-format 3D monitors up to 55". Paired with the EndoSURGERY 3D Spectar platform and the Spectar 3D camera head, they provide depth-accurate visualisation for the whole surgical team.',
      features: [
        'Large-format 3D monitors up to 55"',
        'Stereoscopic (3D) visualisation for the surgical team',
        'For the EndoSURGERY 3D Spectar platform',
        'Depth-accurate imaging for complex procedures',
        'Supplied by established medical-display manufacturers'
      ],
      specifications: {
        type: '3D surgical monitor',
        sizes: 'up to 55"',
        imaging: 'Stereoscopic 3D',
        application: 'Stereoscopic surgery (EndoSURGERY 3D Spectar)'
      },
      images: ['/products/transparent/xion-monitore-web.png']
    }
  ]
};
